const monthArr = () => {
  const arr = [];
  for (let i = 1; i < 13; i++) {
    arr.push({
      label: `${i}月`,
      value: i,
    });
  }
  return arr;
};
// 获取当前年前十年数据 作为上传绩效审核年
const DateInfo = new Date();
const year = DateInfo.getFullYear();
const yaerList = [];
for (let i = 0; i < 10; i++) {
  const lastYear = year - i;
  yaerList.push({ label: lastYear, value: lastYear });
}

const staticData = {
  monthOption: monthArr(),
  checkStatus: [
    // 审核状态 0暂存 1-待审核，2-审核通过，3-退回
    {
      label: "已审核",
      value: 1,
    },
    {
      label: "未审核",
      value: 2,
    },
    {
      label: "审核失败",
      value: 3,
    },
  ],
  diffCountry: [
    {
      label: "内宾",
      value: 1,
    },
    {
      label: "外宾",
      value: 2,
    },
  ],
};

export const staticObj = staticData;
